"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// Polyfills for IE 11
require("core-js");
// Polyfills for IE edge and older
require("@webcomponents/webcomponentsjs");
// Components
// import discover from '../components/discover/main';
// import explore from '../components/explore/main';
var main_1 = __importDefault(require("../components/article-related/main"));
var main_2 = __importDefault(require("../components/v2/user-interest/main"));
var main_3 = __importDefault(require("../components/v2/article-user-interest/main"));
var main_4 = __importDefault(require("../components/v2/user-library/main"));
var main_5 = __importDefault(require("../components/v2/article-button-favorite/main"));
var main_6 = __importDefault(require("../components/v2/search/main"));
var main_7 = __importDefault(require("../components/v2/topic-show/main"));
var main_8 = __importDefault(require("../components/v2/collection-index/main"));
var ScrollElement_vue_1 = __importDefault(require("../components/v2/scroll-element/ScrollElement.vue"));
var main_9 = __importDefault(require("../components/v2/video-index/main"));
var index_1 = require("video-content/src/index");
var embed_view_1 = require("./embed-view");
var app_service_1 = __importStar(require("./app.service"));
var main_10 = __importDefault(require("../components/job-select/main"));
var toggle_password_1 = require("./toggle-password");
var video_player_1 = require("./video-player");
var style_variant_1 = require("./style-variant");
var main_11 = __importDefault(require("../components/article-abstract-popup-gallery/main"));
var main_12 = __importDefault(require("../components/v2/video-show/main"));
var main_13 = __importDefault(require("../components/v2/article-landing/main"));
index_1.videoContent.init();
main_11.default.init('.visual-abstract-gallery');
(0, embed_view_1.embedView)();
(function () {
    var appService = new app_service_1.default();
    var app = appService.create(function () {
        var baseUrl = '';
        if (typeof BASE_URL === 'string') {
            baseUrl = BASE_URL;
        }
        return new app_service_1.AppDefault(baseUrl);
    });
    var headerHeight = 70;
    var scrollOffset = -headerHeight;
    var onFulfilled = function (values) {
        var messages = values[0];
        var i18nLocale = 'custom';
        var vueI18nOptions = {
            locale: i18nLocale,
            messages: messages,
        };
        var options = {
            axios: app.http,
            vueProductionTip: app.environment !== 'production',
            vueI18n: vueI18nOptions
        };
        // discover.initComponent(options);
        // explore.initComponent(options);
        main_2.default.initComponent(options);
        main_3.default.initComponent(__assign(__assign({}, options), { scrollOffset: scrollOffset }));
        main_4.default.initComponent(options);
        main_7.default.initComponent(__assign(__assign({}, options), { scrollOffset: scrollOffset }));
        main_1.default.initComponent(options);
        var jobSelectSelector = '.app-job-select';
        var jobSelectElements = Array.from(document.querySelectorAll(jobSelectSelector));
        if (jobSelectElements) {
            jobSelectElements.forEach(function (jobSelectElement) {
                main_10.default.initComponent(jobSelectElement, jobSelectSelector, {
                    vueProductionTip: options.vueProductionTip,
                });
            });
        }
        main_5.default.initComponent(options);
        main_6.default.initComponent(__assign(__assign({}, options), { scrollOffset: scrollOffset }));
        var elements = document.querySelectorAll('.js-toggle-password');
        elements.forEach(function (element) {
            (0, toggle_password_1.togglePassword)(element);
        });
        (0, video_player_1.initVideoIFramePlayersInsideModal)(document.querySelectorAll('.js-handle-modal-video-events'));
        main_8.default.initComponent(__assign(__assign({}, options), { scrollOffset: scrollOffset }));
        main_9.default.initComponent(__assign(__assign({}, options), { scrollOffset: scrollOffset }));
        main_12.default.initComponent(__assign(__assign({}, options), { scrollOffset: scrollOffset }));
        main_13.default.initComponent(__assign(__assign({}, options), { scrollOffset: scrollOffset }));
        var scrollElementSelector = '.app-scroll-element';
        var scrollElements = Array.from(document.querySelectorAll(scrollElementSelector));
        if (scrollElements) {
            scrollElements.forEach(function (scrollElement) {
                var _a;
                var targetSelector = (_a = scrollElement.dataset.targetSelector) !== null && _a !== void 0 ? _a : null;
                if (!targetSelector) {
                    console.warn('Dataset "targetSelector" ("data-target-selector") not found.'
                        + " Element \"".concat(scrollElementSelector, "\""));
                    return;
                }
                var vm = new ScrollElement_vue_1.default({
                    propsData: {
                        context: document,
                        targetSelector: targetSelector,
                    },
                });
                vm.$mount(scrollElementSelector);
            });
        }
        Array.from(document.querySelectorAll('.js-load-style-variant'))
            .map(function (element) {
            var _a;
            var styleVariant = (_a = element.dataset.styleVariant) !== null && _a !== void 0 ? _a : null;
            if (styleVariant === null) {
                console.warn('Dataset "data-style-variant" is empty');
                return;
            }
            var removeStyleDisplay = typeof element.dataset.removeStyleDisplay !== 'undefined';
            (0, style_variant_1.addStyleVariantClasses)(element, styleVariant, removeStyleDisplay);
        });
    };
    Promise.all([app.i18nMessages])
        .then(onFulfilled);
})();
